import React from 'react';

import { Frequency } from '@ndvr/customer-api';

import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/utils/cn';
import { titleCase } from 'utils';

interface TaskRecurrenceChipProps {
    frequency?: Frequency | null;
    className?: string;
    stopPropagation?: boolean;
}

export const TaskRecurrenceChip: React.FC<TaskRecurrenceChipProps> = ({
    frequency,
    className,
    stopPropagation = true,
}) => {
    if (!frequency) return null;

    const label = `Repeats ${titleCase(frequency).toLowerCase()}`;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span
                    className={cn('shrink-0', className)}
                    onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
                    onMouseDown={stopPropagation ? (e) => e.stopPropagation() : undefined}
                    aria-label="Recurring task"
                >
                    <Badge variant="secondary" className="cursor-default">
                        ↻
                    </Badge>
                </span>
            </TooltipTrigger>
            <TooltipContent>{label}</TooltipContent>
        </Tooltip>
    );
};
